export default "<p>\n  category works!\n</p>\n"